<template>
  <div>
    <vxe-grid
      size="small"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>

      <template v-slot:displaySpec="{ row }">
        <span>COLOR:</span>
        <span>{{ row.goodsColor }}</span>
        <span>{{ row.goodsColorEn }}</span>
        <br />
        <span>SIZE:</span>
        <span>{{ row.goodsSize }}</span>
      </template>
      <template v-slot:displayNo="{ row }">
        <span>{{ row.ncNo }}</span>
        <br />
        <span>{{ row.amzSkuNo }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
          this.$emit('open-detail', data)
          break
      }
    },
  },
}
</script>
